import { App, notification } from "antd";
import { _T } from "../../../../base-react/src/Localization";
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var ClassRoundSource = models.rounds.ClassRoundSource;
var RoundTeamSource = models.teams.RoundTeamSource;
import { useEffect, useRef } from "react";
import { useBlocker } from "react-router-dom";
export const safeDeleteRound = (round, modal) => {
    const classRoundSource = ClassRoundSource(round.class_id);
    const roundTeamSource = RoundTeamSource(round.round_id);
    return Api.read(roundTeamSource.url)
        .then(async (teams) => {
        if (Array.isArray(teams) && teams.length > 0) {
            modal.error({
                title: _T('round.warnings.removeTeamsBeforeDelete.title'),
                content: _T('round.warnings.removeTeamsBeforeDelete.content'),
            });
        }
        else {
            let errorsFound = 0;
            var roundIdsToDelete = [
                round.round_id
            ];
            // Also delete all child rounds
            if (round.round_children > 0) {
                await Api.read(classRoundSource.url)
                    .then((classRounds) => {
                    roundIdsToDelete = [
                        ...classRounds.filter(a => a.round_parent_id == round.round_id).map(child => child.round_id),
                        round.round_id,
                    ];
                });
            }
            for (let index in roundIdsToDelete) {
                await Api.destroy(`${classRoundSource.url}/${roundIdsToDelete[index]}`)
                    .then((rounds) => {
                })
                    .catch((err) => {
                    errorsFound++;
                    notification.error({
                        message: err.message
                    });
                });
            }
            return !errorsFound;
        }
    })
        .catch((err) => {
        notification.error({
            message: err.message
        });
    });
};
export function findDifferences(oldData, newData) {
    const differences = {};
    for (const key in oldData) {
        if (JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])) {
            differences[key] = { old: oldData[key], new: newData[key] };
        }
    }
    for (const key in newData) {
        if (!(key in oldData)) {
            differences[key] = { old: undefined, new: newData[key] };
        }
    }
    return differences;
}
export const shuffleArray = (array) => {
    const shuffled = [...array]; // make a copy to avoid mutating the original array
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};
export const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
    }
    return chunks;
};
export const sanitizeRoundPriorityGroups = (groups, options) => {
    if (!Array.isArray(groups)) {
        return [];
    }
    return groups.map((group) => {
        const sanitizedGroup = {
            name: group === null || group === void 0 ? void 0 : group.name,
            class_id: (group === null || group === void 0 ? void 0 : group.class_id) || undefined,
            percentage: (group === null || group === void 0 ? void 0 : group.percentage) != undefined && (group === null || group === void 0 ? void 0 : group.percentage) !== '' ? Number(group.percentage) : undefined,
            max: (group === null || group === void 0 ? void 0 : group.max) != undefined && (group === null || group === void 0 ? void 0 : group.max) !== '' ? Number(group.max) : undefined,
            points: (group === null || group === void 0 ? void 0 : group.points) != undefined && (group === null || group === void 0 ? void 0 : group.points) !== '' ? Number(group.points) : undefined,
            multiplier: (group === null || group === void 0 ? void 0 : group.multiplier) != undefined && (group === null || group === void 0 ? void 0 : group.multiplier) !== '' ? Number(group.multiplier) : undefined,
        };
        if ((options === null || options === void 0 ? void 0 : options.preferMax) && sanitizedGroup.max !== undefined) {
            delete sanitizedGroup.percentage;
        }
        Object.keys(sanitizedGroup).forEach((groupKey) => {
            if (sanitizedGroup[groupKey] === undefined) {
                delete sanitizedGroup[groupKey];
            }
        });
        return sanitizedGroup;
    });
};
export const hasInvalidRoundPriorityGroups = (groups) => {
    if (!Array.isArray(groups) || groups.length === 0) {
        return true;
    }
    return groups.some((group) => {
        return group.percentage !== undefined && group.max !== undefined && group.percentage !== 100;
    });
};
export function useUnsavedChangesGuard(when) {
    const { modal } = App.useApp();
    // refresh/close tab
    useEffect(() => {
        if (!when)
            return;
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return () => window.removeEventListener("beforeunload", handler);
    }, [when]);
    // SPA navigation (data router only)
    const blocker = useBlocker(when);
    const showingRef = useRef(false);
    useEffect(() => {
        if (!when)
            return;
        if (blocker.state !== "blocked")
            return;
        if (showingRef.current)
            return;
        showingRef.current = true;
        modal.confirm({
            title: _T('common.confirm'),
            content: _T('common.unsaved'),
            onOk: () => blocker.proceed(),
            onCancel: () => blocker.reset(),
            afterClose: () => (showingRef.current = false),
        });
    }, [when, blocker]);
}
